import { UpgradePlanDialog } from '@aibees/shared/components';
import { memo } from 'react';
import { useNextSeatPlanName } from '../../hooks/use-next-seat-plan-name';
import type { SeatLimitUpgradeDialogProps as Props } from './types';

/**
 * Resolves the plan to upsell and renders the upgrade dialog. Kept separate so
 * the plans request only fires for workspaces that have hit the seat limit.
 */
export const SeatLimitUpgradeDialog = memo(
  ({ className, state, seat }: Props) => {
    const nextPlanName = useNextSeatPlanName(seat);

    return (
      <UpgradePlanDialog
        className={className}
        state={state}
        planName={nextPlanName}
      />
    );
  }
);

SeatLimitUpgradeDialog.displayName = 'SeatLimitUpgradeDialog';
